import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { entityKeys } from "../queryKeys";
import { getEntityLocationsByCountry } from "../services/entityLocationsByCountry.service";

export const useGetEntityLocationsByCountry = ({ entityId }: { entityId: string }) => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [...entityKeys.locationsByCountry, i18n.language, entityId],
    queryFn: () => getEntityLocationsByCountry(entityId),
    enabled: !!entityId,
  });
};
